"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPlayerIdsForBetsHistory = getPlayerIdsForBetsHistory;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
function getPlayerIdsForBetsHistory(bets) {
    const playersSet = new Set();
    const playerIds = [];
    for (const bet of bets) {
        for (const outcome of bet.outcomes) {
            for (const parameter of outcome.parameters) {
                if (parameter.type === betweb_openapi_axios_1.ParameterType.PlayerId) {
                    const value = Number(parameter.value);
                    if (playersSet.has(value)) {
                        continue;
                    }
                    playersSet.add(value);
                    playerIds.push(value);
                }
            }
        }
    }
    return playerIds;
}
//# sourceMappingURL=getPlayerIdsForBetsHistory.js.map